import CalendarApp from './CalendarApp';
import CalendarQuery from './CalendarQuery';

export {
    CalendarApp,
    CalendarQuery
}

export default CalendarApp;